import InputsForm from 'features/inputs/InputsForm';

const CreateProjectPage = () => <InputsForm />;

export default CreateProjectPage;
